// extracted by mini-css-extract-plugin
module.exports = {"container":"DetallesLigaPagoSV_container__yryME","container-loading":"DetallesLigaPagoSV_container-loading__2f1rs","text-loading":"DetallesLigaPagoSV_text-loading__3Y-5C"};